/* eslint-disable global-require */
module.exports = [...require('./Lot/i18n'), 'ails.landingpage.sales.sale.m3', 'ails.landingpage.sales.sale.m4'];
